import { useCallback, useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

export function useCycle(periodMs: number) {
  const reduce = useReducedMotion();
  const [phase, setPhase] = useState<'problem' | 'solution'>(reduce ? 'solution' : 'problem');
  const [run, setRun] = useState(0);

  useEffect(() => {
    if (reduce) {
      setPhase('solution');
      return;
    }
    setPhase('problem');
    const toSolution = window.setTimeout(() => setPhase('solution'), Math.round(periodMs * 0.42));
    const loop = window.setTimeout(() => setRun((value) => value + 1), periodMs);
    return () => {
      window.clearTimeout(toSolution);
      window.clearTimeout(loop);
    };
  }, [reduce, periodMs, run]);

  const replay = useCallback(() => setRun((value) => value + 1), []);

  return { phase, reduce: Boolean(reduce), replay, run };
}
